import { Component, OnInit, ViewEncapsulation, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Tercero } from '../../../models/tercero';
import { EventRegistroTerceroResponse, TerceroRegistroComponent } from '../tercero-registro.component';

@Component({
    selector: 'app-tercero-registro-modal',
    templateUrl: './tercero-registro-modal.component.html',
    styleUrls: ['./tercero-registro-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TerceroRegistroModalComponent {

    public titulo: string;
    public modalAction: string; /** registrar/editar/detalle **/
    public tercero: Tercero;
    public terceroId: Tercero;
    public puedeCerrarModal:boolean;
    public camposAConfirmar:string[];

    @ViewChild("terceroRegistro") terceroRegistroCompoment: TerceroRegistroComponent;

    constructor
    (
        public matDialogRef: MatDialogRef<TerceroRegistroModalComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
    ) 
    {
        this.modalAction = _data.action;
        this.puedeCerrarModal = _data.puedeCerrarModal == null ? true : _data.puedeCerrarModal;
        this.camposAConfirmar = _data.camposAConfirmar || [];
        
        switch (this.modalAction) {
            case "registrar":
                this.titulo = "Registrar Tercero";
                break;
            case "editar":
                this.titulo = "Editar Tercero";
                this.terceroId = _data.terceroId;
                break;
            case "detalle":
                this.titulo = "Detalles del Tercero";
                this.terceroId = _data.terceroId;
                break;
        }
    }

    public puedeGuardarTercero():boolean {
        return this.terceroRegistroCompoment?.puedeGuardarTercero();
    }
    public guardarTercero(){
        this.terceroRegistroCompoment?.guardarTercero();
    }

    public SeRegistroElTercero(respuesta: EventRegistroTerceroResponse): void {
        this.matDialogRef.close(respuesta);
    }
    public SeEditoElTercero(respuesta: EventRegistroTerceroResponse): void {
        this.matDialogRef.close(respuesta);
    }
    
}
